;
define("social_sharing_flyout_hover.tpl", function(){});

